import React from "react";
import styles from "./firstSection.module.css";
import firstsectionbg from "../../../public/assets/firstSectionBg.png";
import { Col, Row } from "react-bootstrap";
import bluetick from "../../../public/assets/bluetick.svg";
import CalculatorBox from "./calculatorBox";
import { useMyContext } from "../../../myContext";
import OfflineCalculatorBox from "../offlineCalculatorBox";

function FirstSection() {
  const {offlineTransactionFlow, loadingLogo} = useMyContext();
  return (
    <>
      <img src={firstsectionbg} alt="bg" className={styles.image}></img>
      <Row className={`g-0 ${styles.showweb}`}>
        <Col xl={7} lg={6} md={12} className={styles.firstsectionCol}>
          <p className={styles.firstSectionHeading}>
            The <span className={styles.bluetext}>Simplest</span>,{" "}
            <span className={styles.bluetext}>Fastest</span> and{" "}
            <span className={styles.bluetext}>Cheapest</span> Way to Send Money
            Abroad
          </p>
          <p className={styles.checkBoxDiv}>
            <img
              src={bluetick}
              alt="bluetick"
              className={styles.bluetickImage}
            ></img>{" "}
            Lowest Exchange Rates
          </p>
          <p className={styles.checkBoxDiv}>
            <img
              src={bluetick}
              alt="bluetick"
              className={styles.bluetickImage}
            ></img>{" "}
            No Hidden Fees
          </p>
          <p className={styles.checkBoxDiv}>
            <img
              src={bluetick}
              alt="bluetick"
              className={styles.bluetickImage}
            ></img>{" "}
            Simplified, Fully Online Process
          </p>
        </Col>
        <Col xl={5} lg={6} md={12} className={styles.firstsectionCol2}>
        {!loadingLogo ? "" : offlineTransactionFlow === true ? <OfflineCalculatorBox /> : <CalculatorBox />}
        </Col>
      </Row>
    </>
  );
}

export default FirstSection;
